export default [
    {
        text: "Context Property",
        xmlType: "contextProperty"
    },
    {
        text: "Constant Value",
        xmlType: "constantValue"
    },
    {
        text: "User Property",
        xmlType: "userProperty"
    },
    {
        text: "Current time (sec)",
        xmlType: "currentTimeSec"
    },
    {
        text: "Current time (millisec)",
        xmlType: "currentTimeMilliSec"
    },
    {
        text: "Event type",
        xmlType: "constantValue"
    }
];